function prNextEasternMidnight(now) {
  const formatter = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
  const parts = (time) => Object.fromEntries(formatter.formatToParts(new Date(time)).filter(part => part.type !== 'literal').map(part => [part.type, Number(part.value)]));
  const today = parts(now);
  const target = Date.UTC(today.year, today.month - 1, today.day + 1);
  let result = target;
  for (let i = 0; i < 3; i++) {
    const local = parts(result);
    result += target - Date.UTC(local.year, local.month - 1, local.day, local.hour, local.minute, local.second);
  }
  return result;
}

if (!customElements.get('pr-promotions')) {
  customElements.define('pr-promotions', class extends HTMLElement {
    connectedCallback() {
      if (!this.querySelector('[data-countdown]')) return;
      const setLabel = (text) => { const label = this.querySelector('[data-sale-label]'); if (label) label.textContent = text; };
      const hide = (selector) => { const element = this.querySelector(selector); if (element) element.hidden = true; };
      const raw = this.dataset.end?.trim();
      const personal = this.dataset.personal === 'true';
      const eastern = this.dataset.timezone === 'America/New_York';
      const daily = personal && this.dataset.daily === 'true';
      const period = 24 * 3600000;
      const key = `pr-offer-deadline:${this.dataset.campaign || 'launch'}${daily ? ':daily-24h' : ''}`;
      let end;
      if (eastern) {
        end = prNextEasternMidnight(Date.now());
      } else if (personal) {
        try {
          const stored = Number(localStorage.getItem(key));
          end = Number.isFinite(stored) && stored > 0 ? stored : Date.now() + (daily ? period : Number(this.dataset.hours || 4) * 3600000);
          if (end !== stored) localStorage.setItem(key, String(end));
        } catch {
          setLabel('Explore our latest offers');
          hide('.pr-sale-clock');
          return;
        }
      } else {
        if (!raw) return;
        end = Date.parse(raw);
      }
      if (!Number.isFinite(end) || (!personal && !eastern && !/(Z|[+-]\d{2}:\d{2})$/.test(raw))) {
        setLabel('Set a valid sale end date');
        hide('.pr-sale-clock');
        return;
      }
      const accessible = this.querySelector('[data-accessible-end]');
      const announceEnd = () => { if (accessible) accessible.textContent = `${eastern ? 'Resets at midnight US Eastern time:' : daily ? 'Next daily reset' : 'Your offer window ends'} ${new Date(end).toLocaleString(undefined, { dateStyle: 'long', timeStyle: 'long' })}.`; };
      if (daily) setLabel('Next daily reset in:');
      announceEnd();
      const update = () => {
        const now = Date.now();
        if (eastern && end <= now) { end = prNextEasternMidnight(now); announceEnd(); }
        if (!eastern && daily && end <= now) {
          end += (Math.floor((now - end) / period) + 1) * period;
          try { localStorage.setItem(key, String(end)); } catch { /* Keep this visit's daily cycle running. */ }
          announceEnd();
        }
        const seconds = Math.max(0, Math.ceil((end - now) / 1000));
        if (seconds === 0) {
          setLabel('Your offer window has ended.');
          hide('.pr-sale-clock');
          clearInterval(this.timer);
          return;
        }
        const days = (daily || eastern) ? 0 : Math.floor(seconds / 86400);
        this.querySelector('[data-days-unit]').hidden = days === 0;
        const parts = { d: days, h: (daily || eastern) ? Math.floor(seconds / 3600) : Math.floor(seconds / 3600) % 24, m: Math.floor(seconds / 60) % 60, s: seconds % 60 };
        Object.entries(parts).forEach(([unit, value]) => {
          const digits = String(value).padStart(2, '0');
          this.querySelector(`[data-digit="${unit}0"]`).textContent = digits.slice(0, -1);
          this.querySelector(`[data-digit="${unit}1"]`).textContent = digits.slice(-1);
        });
      };
      this.timer = setInterval(update, 1000);
      update();
    }
    disconnectedCallback() { clearInterval(this.timer); }
  });
}
